module.exports = __webpack_public_path__ + "static/media/sf_300.8370ccb7e9e537969381a2212fc1d11f.png";